export default {
  GET_PUSH_LIST: '/manage/push/findList',
  GET_AUTO_PUSH_LIST: '/manage/push/findAutoSendList',
  SAVE_PUSH: '/manage/push/save',
  EDIT_PUSH: '/manage/push/update',
  DELETE_PUSH: '/manage/push/delete',
  FIND_PUSH: '/manage/push/find',
  FIND_STATISTICS: '/manage/push/statistics',
  RECALL: '/manage/push/recall'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/push.js